import cn from 'clsx'
import React, { ForwardedRef, forwardRef } from 'react'

export interface FormRadioButtonProps
  extends React.HTMLProps<HTMLInputElement> {
  label: string | undefined
  value: string | undefined
  hint?: string
  checkedValue?: string
}

export const FormRadioButton = forwardRef(
  (
    { label, hint, checkedValue, value, ...props }: FormRadioButtonProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <label
        htmlFor={label}
        className={cn(
          'w-full px-5 py-6 border border-deepPurple flex justify-between items-center cursor-pointer'
        )}
      >
        <div className="flex items-center">
          <span
            className={cn(
              'w-5 h-5 rounded-full mr-2 border border-white flex justify-center items-center before:bg-white before:opacity-0 before:rounded-full before:w-3 before:h-3 before:content-[" "] before:block before:transition-opacity',
              {
                'before:opacity-100 ': checkedValue === value,
              }
            )}
          />
          <input
            ref={ref}
            id={label}
            type="radio"
            value={value}
            {...props}
            aria-label={label}
            hidden
          />
          <span>{label}</span>
        </div>
        <span>{hint}</span>
      </label>
    )
  }
)

FormRadioButton.displayName = 'FormRadioButton'
